<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15rIDAW/tc-custom/9780802192370.jpg?1708746936011" alt="This image is the cover for the book Sweet Sunday"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sweet Sunday
      </h1>
      <p class="bookDescription body article font2">
        <b>1969 is a time of turmoil and murder for a New York PI in this “</b><b>twisty, sometimes terrifying” novel from the author of the acclaimed Inspector Troy Novels (<i>Kirkus Reviews</i></b><b>).</b><br/>  <br/> New York PI Turner Raines is a has-been—and the things he has been include a broken civil rights worker, a second-rate lawyer, and a tenth-rate yippie reporter. But in 1969, as the USA is about to land a man on the moon and the Vietnam War is ripping the country to pieces, Raines is working as a skip tracer, making sure draft-dodgers are safe and sound in Canada.<br/>  <br/> When Raines returns from Toronto, he discovers that his oldest friend, a left-wing journalist, has been murdered, and has taken his latest powder keg of a story to his grave. Following the trail of his buddy’s death, Turner hits the road for the Texas of his childhood, confronted anew with his divided family, and blown into the dangerous path of a band of brothers from ’Nam whose secrets could not only change Turner’s life but the country itself.<br/>  <br/> “Atmospheric . . . absorbingly intelligent.” —<i>Financial Times</i><br/>  <br/> “John Lawton writes great thrillers. . . . He can hold his own with contemporaries Alan Furst and Phillip Kerr.” —<i>Boston Herald</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Lawton
      </h2>
      
      <p class="authorDescription body article">John Lawton is the author of ten novels, including <I>Second Violin</I>, <I>Flesh Wounds</I>, and <I>Bluffing Mr. Churchill</I>. His thriller <I>Black Out</I> won a WH Smith Fresh Talent Award, <I>A Little White Death</I> was named a <I>New York Times</I>&#160;Notable Book, and his latest novel <I>A Lily of the Field</I> was named one of the best thrillers of the year by Marilyn Stasio of the<I> New York Times</I>. At the moment he lives in Derbyshire, England, but can often be found (or lost) elsewhere.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grove/Atlantic Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f7a9b2f0